import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-adjustable-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './adjustable-loader.component.html',
  styleUrl: './adjustable-loader.component.scss'
})
export class AdjustableLoaderComponent implements OnInit {
  @Input() isLoading!: boolean;
  @Input() topOffset: string = '0vh';

  constructor() { }

  ngOnInit(): void { }

}
